import ApiService from "@/core/services/api.service";

// action types
export const FETCH_USER_STATICS = "fetchUserStatics";

// mutation types
export const SET_USER_STATICS = "setUserStatics";

const state = {
  userStatics: []
};

const getters = {
  userStatics(state) {
    return state.userStatics;
  }
};

const actions = {
  [FETCH_USER_STATICS](context, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query("statics", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_USER_STATICS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_USER_STATICS](state, payload) {
    state.userStatics = payload;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
